import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => <svg fill="none" height={14} viewBox="0 0 14 14" width={14} xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.667 3.5 5.25 9.917 2.333 7" stroke="#currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} /></svg>;
export default SvgCheck;
export { SvgCheck };